// Local month range utilities — no external date libraries.
// All boundaries are in browser local time.

import { localDateString } from "./calendarCodec";

export function parseYearMonth(month) {
  // month is "YYYY-MM"
  const [yearStr, monthStr] = month.split("-");
  return { year: parseInt(yearStr, 10), month: parseInt(monthStr, 10) };
}

export function localMonthStart(month) {
  const { year, month: m } = parseYearMonth(month);
  // Local midnight on the 1st of the given month
  return new Date(year, m - 1, 1, 0, 0, 0, 0);
}

export function localNextMonthStart(month) {
  const { year, month: m } = parseYearMonth(month);
  // Local midnight on the 1st of the NEXT month
  return new Date(year, m, 1, 0, 0, 0, 0);
}

export function localMonthEnd(month) {
  // Inclusive: last millisecond before next month starts
  const nextStart = localNextMonthStart(month);
  return new Date(nextStart.getTime() - 1);
}

export function monthRangeApiParams(month) {
  const start = localMonthStart(month);
  const end = localMonthEnd(month);
  return {
    due_after: start.toISOString(),
    due_before: end.toISOString(),
  };
}

export function daysInMonth(month) {
  const { year, month: m } = parseYearMonth(month);
  // Day 0 of next month = last day of current month
  return new Date(year, m, 0).getDate();
}

export function getLocalMonthLabel(month, locale) {
  const { year, month: m } = parseYearMonth(month);
  const d = new Date(year, m - 1, 1);
  const monthName = d.toLocaleString(locale || "uk-UA", { month: "long" });
  const capitalized = monthName.charAt(0).toUpperCase() + monthName.slice(1);
  return `${capitalized} ${year}`;
}

/** Ukrainian locative month names for phrases like "N задач у липні". */
const UK_MONTH_LOCATIVE = [
  "січні",
  "лютому",
  "березні",
  "квітні",
  "травні",
  "червні",
  "липні",
  "серпні",
  "вересні",
  "жовтні",
  "листопаді",
  "грудні",
];

/**
 * User-facing monthly task count phrase.
 * Example (uk): "211 задач у липні"
 */
export function formatMonthlyTaskCount(month, count, locale) {
  const { month: m } = parseYearMonth(month);
  const n = typeof count === "number" ? count : 0;
  if ((locale || "uk-UA").toLowerCase().startsWith("uk")) {
    return `${n} задач у ${UK_MONTH_LOCATIVE[m - 1]}`;
  }
  return `${n} tasks · ${getLocalMonthLabel(month, locale)}`;
}

export function isCurrentLocalMonth(month) {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  return month === `${yyyy}-${mm}`;
}

export function prevMonth(month) {
  const { year, month: m } = parseYearMonth(month);
  const d = new Date(year, m - 2, 1);
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  return `${y}-${mo}`;
}

export function nextMonth(month) {
  const { year, month: m } = parseYearMonth(month);
  const d = new Date(year, m, 1);
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  return `${y}-${mo}`;
}

export function todayLocalMonth() {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  return `${yyyy}-${mm}`;
}

export function todayLocalDate() {
  return localDateString(new Date());
}
